@if (sharedService.getUser() | async) {
  @if (sharedService.isUserCreditHold) {
    <app-credit-hold-message> </app-credit-hold-message>
  }
}

<div class="cx-review mt-3">
  <!-- TITLE -->
  <h3 class="cx-review-title d-none d-lg-block d-xl-block">
    {{ 'checkoutReview.review' | cxTranslate }}
  </h3>

  <div class="cx-review-summary row">
    @if ((steps$ | async)?.slice(0, -1); as steps) {
      <div class="col-md-12 col-lg-6 col-xl-6 cx-review-payment-col">
        @for (step of paymentSteps(steps); track step) {
          @switch (step.type[0]) {
            @case (checkoutStepTypePaymentType) {
              <ng-container *ngTemplateOutlet="poNumber"></ng-container>
            }
            @case (checkoutStepTypePaymentType) {
              <ng-container *ngTemplateOutlet="paymentType"></ng-container>
            }
            @case (checkoutStepTypePaymentDetails) {
              <ng-container *ngTemplateOutlet="paymentMethod"></ng-container>
            }
            <!--            <ng-container *ngSwitchCase="checkoutStepTypeDeliveryAddress">-->
            <!--              <ng-container *ngTemplateOutlet="costCenter"></ng-container>-->
          <!--            </ng-container>-->
        }
      }
    </div>
    <div class="col-md-12 col-lg-6 col-xl-6 cx-review-shipping-col">
      @for (step of deliverySteps(steps); track step) {
        @switch (step.type[0]) {
          @case (checkoutStepTypeDeliveryAddress) {
            <ng-container *ngTemplateOutlet="deliveryAddress"></ng-container>
          }
          <!--            <ng-container *ngSwitchCase="checkoutStepTypeDeliveryMode">-->
          <!--              <ng-container *ngTemplateOutlet="deliveryMode"></ng-container>-->
        <!--            </ng-container>-->
      }
    }
  </div>
}
</div>

<!-- PO NUMBER SECTION -->
<ng-template #poNumber>
  <div class="cx-review-summary-card">
    <cx-card [content]="getPoNumberCard(poNumber$ | async) | async"></cx-card>
    <div class="cx-review-summary-edit-step">
      <a
        [attr.aria-label]="'checkoutReview.editPaymentType' | cxTranslate"
          [routerLink]="
            {
              cxRoute: getCheckoutStepUrl(checkoutStepTypePaymentType)
            } | cxUrl
          "
        >
        <cx-icon aria-hidden="true" [type]="iconTypes.PENCIL"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>

<!-- PAYMENT TYPE SECTION -->
<ng-template #paymentType>
  <div class="cx-review-summary-card">
    @if (paymentType$ | async; as paymentType) {
      <cx-card
        [content]="getPaymentTypeCard(paymentType) | async"
      ></cx-card>
    }
    <div class="cx-review-summary-edit-step">
      <a
        [attr.aria-label]="'checkoutReview.editPaymentType' | cxTranslate"
          [routerLink]="
            {
              cxRoute: getCheckoutStepUrl(checkoutStepTypePaymentType)
            } | cxUrl
          "
        >
        <cx-icon aria-hidden="true" [type]="iconTypes.PENCIL"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>

<!-- COST CENTER SECTION -->
<ng-template #costCenter>
  @if (isAccountPayment$ | async) {
    <div class="cx-review-summary-card">
      @if (costCenter$ | async; as costCenter) {
        <cx-card [content]="getCostCenterCard(costCenter) | async"></cx-card>
      }
      <div class="cx-review-summary-edit-step">
        <a
          [attr.aria-label]="'checkoutReview.editDeliveryAddressDetails' | cxTranslate"
            [routerLink]="
              {
                cxRoute: getCheckoutStepUrl(checkoutStepTypeDeliveryAddress)
              } | cxUrl
            "
          >
          <cx-icon aria-hidden="true" [type]="iconTypes.PENCIL"></cx-icon>
        </a>
      </div>
    </div>
  }
</ng-template>

<!-- DELIVERY ADDRESS SECTION -->
<ng-template #deliveryAddress>
  @if (deliveryAddress$ | async; as deliveryAddress) {
    <div class="cx-review-summary-card cx-review-card-address">
      <cx-card [content]="getDeliveryAddressCard(deliveryAddress) | async"></cx-card>
      <div class="cx-review-summary-edit-step">
        <a
          [attr.aria-label]="'checkoutReview.editDeliveryAddressDetails' | cxTranslate"
          [routerLink]="
            {
              cxRoute: getCheckoutStepUrl(checkoutStepTypeDeliveryAddress)
            } | cxUrl
          "
          >
          <cx-icon aria-hidden="true" [type]="iconTypes.PENCIL"></cx-icon>
        </a>
      </div>
    </div>
  }
</ng-template>

<!-- DELIVERY MODE SECTION -->
<ng-template #deliveryMode>
  <div class="cx-review-summary-card cx-review-card-shipping">
    @if (deliveryMode$ | async; as deliveryMode) {
      <cx-card
        [content]="getDeliveryModeCard(deliveryMode) | async"
      ></cx-card>
    }
    <div class="cx-review-summary-edit-step">
      <a
        [attr.aria-label]="'checkoutReview.editDeliveryMode' | cxTranslate"
        [routerLink]="{ cxRoute: getCheckoutStepUrl(checkoutStepTypeDeliveryMode) } | cxUrl"
        >
        <cx-icon aria-hidden="true" [type]="iconTypes.PENCIL"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>

<!-- PAYMENT METHOD SECTION -->
<ng-template #paymentMethod>
  <div class="cx-review-summary-card cx-review-card-payment">
    <div>
      @if (paymentDetails$ | async; as paymentDetails) {
        <cx-card
          [content]="getPaymentMethodCard(paymentDetails) | async"
        ></cx-card>
      }
    </div>
    <div class="cx-review-summary-edit-step">
      <a
        [attr.aria-label]="'checkoutReview.editPaymentDetails' | cxTranslate"
        [routerLink]="{ cxRoute: getCheckoutStepUrl(checkoutStepTypePaymentDetails) } | cxUrl"
        >
        <cx-icon aria-hidden="true" [type]="iconTypes.PENCIL"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>
<!-- CART ITEM SECTION -->
@if (cart$ | async; as cart) {
  <div class="cx-review-cart-total d-none d-lg-block d-xl-block">
    {{ 'cartItems.cartTotal' | cxTranslate: { count: cart.deliveryItemsQuantity } }}:
    {{ cart.totalPrice?.formattedValue }}
  </div>
  <h4 class="cx-review-cart-heading d-block d-lg-none d-xl-none">
    {{ 'checkoutReview.placeOrder' | cxTranslate }}
  </h4>
  @if (entries$ | async; as entries) {
    <div class="cx-review-cart-item col-md-12">
      <cx-promotions [promotions]="(cart.appliedOrderPromotions || []).concat(cart.potentialOrderPromotions || [])">
      </cx-promotions>
      <app-custom-cart-item-list-stock [items]="entries" [promotionLocation]="promotionLocation" [readonly]="true">
      </app-custom-cart-item-list-stock>
    </div>
  }
}
</div>
